import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { BadgeCheck, Factory, Loader2, MapPin } from 'lucide-react';
import { market } from '../lib/api';

export default function Directory({ kind }) {
  const [items, setItems] = useState(null);
  const isBrand = kind === 'brands';
  useEffect(() => {
    setItems(null);
    (isBrand ? market.brands() : market.manufacturers()).then(d => setItems(d.items)).catch(() => setItems([]));
  }, [isBrand]);

  return (
    <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 space-y-5" data-testid={`directory-${kind}`}>
      <div className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="font-heading font-black text-3xl md:text-4xl">{isBrand ? 'Shop by brand' : 'Indian manufacturers'}</h1>
          <p className="text-ink/70 mt-1">{isBrand ? 'Every brand here is verified by BharatCart.' : 'Buy directly from verified factories across India.'}</p>
        </div>
        <Link to={`/partner/register?type=${isBrand ? 'brand_owner' : 'manufacturer'}`} data-testid="directory-register-link" className="btn-outline text-sm">
          {isBrand ? 'Register your brand' : 'Register as a manufacturer'}
        </Link>
      </div>
      {!items ? <Loader2 className="w-6 h-6 animate-spin text-[#E67E22]"/> : items.length === 0 ? (
        <p data-testid="directory-empty" className="text-ink/60">No {isBrand ? 'brands' : 'manufacturers'} yet. Be the first to register.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
          {items.map(x => (
            <Link key={x.id} to={`/${kind}/${x.slug}`} data-testid={`directory-item-${x.slug}`} className="card-soft p-4 flex items-center gap-3">
              <span className="w-12 h-12 rounded-xl bg-[#FFF3E0] grid place-items-center overflow-hidden shrink-0">
                {x.logo_url ? <img src={x.logo_url} alt="" className="w-full h-full object-cover"/> : isBrand ? <b className="text-[#D35400]">{x.name[0]}</b> : <Factory className="w-5 h-5 text-[#D35400]"/>}
              </span>
              <span className="min-w-0">
                <span className="font-semibold flex items-center gap-1 truncate">{x.name}<BadgeCheck className="w-4 h-4 text-[#1B5E20] shrink-0"/></span>
                <span className="text-xs text-ink/60 flex items-center gap-1">
                  {isBrand ? `${x.official ? 'Official store · ' : ''}${x.product_count} products` : <><MapPin className="w-3 h-3"/>{x.city}, {x.state}</>}
                </span>
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
